// extracted by mini-css-extract-plugin
module.exports = {"hot":"RoomSensor_hot__3cGoI","cold":"RoomSensor_cold__1xEIC"};